// extracted by mini-css-extract-plugin
module.exports = {"d2xTeaserA":"A_AU_d2xTeaserA__qy5nt"};